/**
 * THE STARRED BAND'S PAGING (ITP-E-204-06, critique C-13; no longer a link since ITP-E-240-11). The band filters the
 * messages loaded so far, so a starred message older than the first page is only reached by loading older pages. While
 * one is not loaded and older pages exist, the band is 'older-starred': the thread pages older messages by itself, as it
 * does on a scroll to the top. With nothing starred, or nothing starred that could still be loaded, it says
 * "No starred messages." instead of standing blank. Outside the band the thread's own paging applies, so this answers
 * 'none'.
 */

export type StarredBandState = 'older-starred' | 'none-starred' | 'none';

export interface StarredBandFacts {
  starredIds: ReadonlySet<string>;
  loadedIds: ReadonlySet<string>;
  band: string;
  /** Whether the conversation has messages older than those loaded. */
  hasOlder: boolean;
}

export function starredBandState({starredIds, loadedIds, band, hasOlder}: StarredBandFacts): StarredBandState {
  if (band !== 'starred') {
    return 'none';
  }
  const starred = [...(starredIds || [])];
  if (hasOlder && starred.some(id => !loadedIds.has(id))) {
    return 'older-starred';
  }
  return starred.some(id => loadedIds.has(id)) ? 'none' : 'none-starred';
}
